export default "__VITE_ASSET__DoGtGPBq__"